import {StaffPermissions} from "../components/Admin/organisms/Accounts/types";
import {CommentDto, Order} from "./orders";
import {FilesDto} from "../store/slices/cars/types";
import {LanguageType} from "../common/constants";
import {SubscriptionsDto} from "../components/Admin/organisms/Subscriptions/types";

export enum UserStatus {
  INVITE_PENDING = 'INVITE_PENDING',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  INVITE_ACCEPTED = 'INVITE_ACCEPTED',
  INVITE_CANCELED = 'INVITE_CANCELED',
}

export enum UserRoles {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT',
}
export type User = {
  address: string;
  city: string;
  companyName?: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  country: string;
  dateOfBirth: Date | null;
  licensePermitDate: Date | null;
  passportExpiration: Date | null;
  drivingLicenseExpiration: Date | null;
  drivingLicense: File |  FilesDto | null;
  proofOfAddressDoc: File |  FilesDto | null;
  email: string;
  id?: string;
  licenseNumber: string;
  phoneNumber: string;
  passport: File |  FilesDto | null;
  password: string;
  isVerified: boolean;
  activeRental?: string;
  postalCode: string;
  vat?: string;
  activeSubscriptions?: Date
  rentsCount?: number;
  totalSpent?: number;
  rate?: number;
  isArchived?: boolean;
  lastLoginDate?: Date;
  status?: UserStatus;
  permissions?: StaffPermissions;
  role?: UserRoles
  orders?: Array<Order>
  comments?: Array<CommentDto>;
  subscriptions?: Array<SubscriptionsDto>;
  language?: LanguageType;
  createdAt?: Date
};
